__webpack_require__.p = "/AdventureSimWest/";